import { EMAIL, EMAIL2, PHONE_DISPLAY, PHONE_TEL, PHONE2_DISPLAY, PHONE2_TEL, LOCATIONS } from "@/data/content";
import { LOGO } from "@/data/logoData";

export default function Footer({ onHome }) {
  return (
    <footer className="border-t border-slate-800 px-4 pb-28 pt-14 sm:px-6 md:pb-14 lg:px-8" data-testid="portal-footer">
      <div className="mx-auto grid max-w-7xl gap-10 sm:grid-cols-2 lg:grid-cols-3 lg:gap-12">
        <div>
          <button
            onClick={onHome}
            aria-label="Back to gateway"
            className="inline-block rounded-2xl bg-white px-6 py-4 transition-transform sm:px-7 sm:py-5 duration-300 hover:scale-105"
          >
            <img src={LOGO} alt="Bigboss Digitech — ELV and smart automation company logo" width="1280" height="560" className="h-12 w-auto sm:h-16" data-testid="footer-logo" />
          </button>
          <p className="mt-2 font-tech text-[10px] uppercase tracking-[0.35em] text-slate-500">
            secure | connect | automate
          </p>
          <p className="mt-5 max-w-xs text-xs leading-relaxed text-slate-400">
            Electronic infrastructure since 2002 — 15,000+ residential, commercial and government
            projects executed across India.
          </p>
        </div>
        <div>
          <p className="mb-4 font-tech text-[10px] uppercase tracking-[0.3em] text-slate-500">Contact</p>
          <a href={`mailto:${EMAIL}`} className="block break-all text-sm text-slate-300 transition-colors hover:text-brand">{EMAIL}</a>
          <a href={`mailto:${EMAIL2}`} className="mt-1.5 block break-all text-sm text-slate-300 transition-colors hover:text-brand">{EMAIL2}</a>
          <a href={`tel:${PHONE_TEL}`} className="mt-3 block break-all text-sm text-slate-300 transition-colors hover:text-brand">{PHONE_DISPLAY}</a>
          <a href={`tel:${PHONE2_TEL}`} className="mt-1.5 block break-all text-sm text-slate-300 transition-colors hover:text-brand">{PHONE2_DISPLAY}</a>
        </div>
        <div>
          <p className="mb-4 font-tech text-[10px] uppercase tracking-[0.3em] text-slate-500">Offices</p>
          {LOCATIONS.map((l) => (
            <p key={l.id} className="mb-2 text-xs leading-relaxed text-slate-400">
              <span className="font-semibold text-slate-200">{l.city}:</span> {l.address}
            </p>
          ))}
        </div>
      </div>
      <p className="mx-auto mt-12 max-w-7xl border-t border-slate-800/70 pt-6 text-center text-[11px] text-slate-600">
        © {new Date().getFullYear()} Bigboss Digitech. Electronic Solutions & System Integration. All rights reserved.
      </p>
      <p className="mx-auto mt-3 flex max-w-7xl flex-wrap items-center justify-center gap-x-3 gap-y-2 text-center text-[11px]">
        <a href="/privacy-policy.html" className="text-slate-500 transition-colors hover:text-brand" data-testid="footer-privacy-link">Privacy Policy</a>
        <span className="text-slate-700">·</span>
        <a href="/terms-of-service.html" className="text-slate-500 transition-colors hover:text-brand" data-testid="footer-terms-link">Terms of Service</a>
      </p>
    </footer>
  );
}
